import { SegmentedControl } from "./segmented-control";

export interface LanguagePickerProps<T extends string> {
  value: T;
  onValueChange: (value: T) => void;
  languages: T[];
  ariaLabel: string;
  disabledLanguage?: T;
}

export function LanguagePicker<T extends string>({
  value,
  onValueChange,
  languages,
  ariaLabel,
  disabledLanguage,
}: LanguagePickerProps<T>) {
  return (
    <SegmentedControl<T>
      value={value}
      onValueChange={onValueChange}
      ariaLabel={ariaLabel}
      options={languages.map((l) => ({
        value: l,
        label: <span className="font-mono uppercase tracking-[.08em]">{l}</span>,
        disabled: l === disabledLanguage,
      }))}
    />
  );
}
